import { Components, Theme } from '@mui/material';
import { alpha } from '@mui/material/styles';

export default {
  styleOverrides: {
    root: ({ ownerState, theme }) => {
      const createLinkStyles = (color: string) => ({
        color,
        cursor: 'pointer',
        textDecoration: 'none',
        '&:hover': {
          color,
          textDecoration: 'underline',
        },
        '&.disabled': {
          color: alpha(theme.palette.neutral.onSurface, theme.palette.action.disabledOpacity),
          cursor: 'default',
          '&:hover': {
            color: alpha(theme.palette.neutral.onSurface, theme.palette.action.disabledOpacity),
            textDecoration: 'none',
          },
        },
      });
      switch (ownerState.color) {
        case 'primary':
          return createLinkStyles(theme.palette.primary.main);
        case 'secondary':
          return createLinkStyles(theme.palette.secondary.main);
        case 'neutral':
        default:
          return createLinkStyles(theme.palette.neutral.onSurface);
      }
    }
  }
} as Components<Theme>['MuiLink'];